var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickCircleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "717B8FF7-B3E0-4EE6-A75D-CCB4FD4528E8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Akbank-Sanal-POS-\\u015Eifremi-unuttum-4",
    transform: "translate(-302.000000, -96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/ui/correct",
    transform: "translate(302.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10 C0,15.5229998 4.47700024,20 10,20 C15.5229998,20 20,15.5229998 20,10 C20,4.47700024 15.5229998,0 10,0 L10,0 C4.47700024,0 0,4.47700024 0,10 Z",
    id: "Background-Colour",
    fill: "#1DAD65",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5881205,6 L15.9998856,7.41176474 L8.94106162,14.4705887 L7.52929688,13.0588236 L14.5881205,6 Z M5.41176474,8.11764526 L7.52941179,10.2352924 L6.11764717,11.6470571 L4,9.52941 L5.41176474,8.11764526 Z",
    id: "Icon-Colour",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircleIcon);
export default __webpack_public_path__ + "static/media/tick-circle-icon.56fb6965f683b0470c106002b3a168fe.svg";
export { ForwardRef as ReactComponent };